import { useHistory } from 'react-router-dom';
import { useAppSelector } from '@/redux/hooks';
import { TitleEntity } from '@/redux/slices/slice_types';
import { selectCanReadTitles } from '@/redux/selectors/authSelectors';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import NoRoute from '@/components/NoRoute/NoRoute';
import DataTableLayout from '@/components/_common/Layout/DataTableLayout';
import DataTableTitleBar from '@/components/_common/Layout/DataTableTitleBar';
import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import { buildTitleURL, getTitlePath } from '@/_utils/titleUtils';

const TitlesV2 = () => {
  const history = useHistory();
  const currentTableKey = useAppSelector(selectCurrentTableKey);
  const canReadTitles = useAppSelector(selectCanReadTitles);

  const onRowClick = (e: any, title: TitleEntity) => {
    const url = buildTitleURL({ path: getTitlePath(title) });

    if (e?.ctrlKey || e?.metaKey) {
      window.open(url);
    } else {
      history.push(url);
    }
  };

  if (!canReadTitles) return <NoRoute />;
  return (
    <DataTableLayout tableKey="titlesV2" onRowClick={onRowClick}>
      <DataTableTitleBar />
      {currentTableKey === 'titlesV2' && <DataTableFilters disableExportReport />}
    </DataTableLayout>
  );
};

export default TitlesV2;
